import { useContext, useEffect } from 'react'
import { Grid, Stack, Typography } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom'
import DashboardUsageCard from './usageCard';
import GridUsageCard from './gridCard';
import TouGridUsageCard from './touGridCard';
import HotwaterCard from './hotwaterCard';
import Monitor from '../../right-panel/monitor/monitor';
import HotWater from '../../right-panel/hotwater/hotWater';
import { 
    DataContext, 
    DataDispatchContext 
} from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain } from '../../../services/constants'
import { clickAnalyticsTiles, sendViewAnalytics } from '../../common/util/util'

export default function DashboardUsageCards() {
    const small = useMediaQuery('(max-width:450px)');
    const data = useContext(DataContext)
    const dispatch: any = useContext(DataDispatchContext)
    const navigate = useNavigate()

    const handleMonitor = (id: string) => {
        window.scrollTo(0,0)
        dispatch({
            type: 'setRightPanel',
            rightPanel: <Monitor key="monitor"/>
        })
        clickAnalyticsTiles(id)
    }
    const handleReportView = (selected: string) => {
        dispatch({
            type: 'setReportSelected',
            selected
          })
          clickAnalyticsTiles(selected, {}, !!data?.dashboard?.tou)
        navigate('/performance')
    }

    const handleHotwater = () => {
        window.scrollTo(0,0)
        dispatch({
            type: 'setRightPanel',
            rightPanel: <HotWater key="hotwater"/>
        })
        clickAnalyticsTiles("hotwater")
    }

    const isHotwater = data?.dashboard?.hotwater?.isAvailable
    
    useEffect(()=>{
        sendViewAnalytics('/dashboard', {
                domain: analyticsDomain.dashboard,
                name: analyticsPage.dashboard
            })
    },[])
    
    return (
        <>
        <Grid container id="dashboardCards" 
            direction="row"   
            justifyContent="flex-end" 
            spacing={{ 
                xs: custom.spacing.xxs, 
                sm: custom.spacing.sm,  
                md: custom.spacing.sm,
                lg: custom.spacing.sm,
            }} 
            width= "100%"
            px={custom.spacing.md}
            // pb={2}
            >
            <Grid item xs={12} sm={12} md={12} lg={12} 
                mr={custom.spacing.xxs} width="100%">
                <Stack alignItems="center" direction="row">
                    <Typography component={"h2"} 
                        variant="szHeading.Bold.Small" >
                            Today
                    </Typography>
                    <Typography variant="szBody.Regular.Small" 
                        noWrap
                        sx={{ 
                                color: 'sz.colors.gray600',
                                marginLeft: 'auto', 
                            }}>
                        {`${moment.tz(
                            data?.customer?.account?.timezone || 
                            'Pacific/Auckland')
                            .format('dddd, DD MMMM YYYY')}`}
                    </Typography>
                </Stack>
            </Grid>
            <Grid item xs={small?12:6} sm={6} lg={3} 
                    md={data?.rightPanel?6:3} 
                    width="100%" >
                <DashboardUsageCard id="homeUsage" color="home" 
                    content={data?.dashboard?.cards?.homeUsage} 
                    handleCardClick={handleMonitor}/>
            </Grid>
            <Grid item xs={small?12:6} sm={6} lg={3} 
                md={data?.rightPanel?6:3} 
                width="100%" >
                <DashboardUsageCard id="solarProduction" color="solar" 
                    content={data?.dashboard?.cards?.solarUtilization} 
                    handleCardClick={handleMonitor}/>
            </Grid>
            <Grid item xs={small?12:6} sm={6} lg={3}  
                md={data?.rightPanel?6:3}
                width="100%" >
                <DashboardUsageCard id="homeReport" color="home" 
                    content={data?.dashboard?.cards?.homeUsageTotal} 
                    handleCardClick={()=>handleReportView('home')}/>
            </Grid>
            <Grid item xs={small?12:6} sm={6} lg={3} 
                md={data?.rightPanel?6:3}
                width="100%" >
                <DashboardUsageCard id="solarReport" color="solar" 
                    content={data?.dashboard?.cards?.solarUtilTotal} 
                    handleCardClick={()=>handleReportView('solar')} />
           </Grid>
            <Grid item xs={12} 
                    sm={12} 
                    md={isHotwater?data?.rightPanel?12:6:12} 
                    lg={isHotwater?6:12} 
                    width="100%" >
                {!data?.dashboard?.tou && 
                    <GridUsageCard id="gridImport" color="grid" 
                        content={data?.dashboard?.cards?.gridTotal}  
                        handleCardClick={()=>handleReportView('grid')} />
                }
                {data?.dashboard?.tou && 
                    <TouGridUsageCard id="gridImport" color="grid" 
                        content={data?.dashboard?.cards?.tou}  
                        handleCardClick={()=>handleReportView('grid')} />
                }
            </Grid>
            <Grid item xs={12} sm={12}
                    md={isHotwater?data?.rightPanel?12:6:12}  
                    lg={6} width="100%" 
                    display={ isHotwater?'flex':'none' }>
                <HotwaterCard id="hotwater"  
                    content={data?.dashboard?.hotwater?.card}   
                    handleCardClick={handleHotwater}/>
            </Grid>
        </Grid>
        </>  
    )
}